<template>
  <div class="xu-country-code">
    <div class="field-txt" @click="handleOper">
      <span class="txt-label van-ellipsis" :class="{'isDisable': disabled}">{{ showVal }}</span>
      <van-icon name="arrow-down" />
    </div>
    <van-popup v-model="selectShow" position="bottom" :round="true" :style="{ 'height': '80vh' }" get-container="#app">
      <div class="other-content">
        <div class="filter-popup-title">{{ $t('shared.title.selectRegion')}}</div>
        <div class="area-content">
          <van-index-bar :index-list="indexList" :sticky-offset-top="0">
            <van-index-anchor index="Common" />
            <van-cell
              v-for="(item, index) in commonList"
              :key="'common-' + index"
              :title="`${item.country} +${item.value}`"
              :class="{ 'selected': selectVal.value.includes(item.value) }"
              @click="changeVal(item)"
            />

            <div v-for="char in indexList" :key="char">
              <van-index-anchor :index="char" />
              <van-cell
                v-for="(item, index) in countryList[char]"
                :key="'country-' + index"
                :title="`${item.country} +${item.value}`"
                :class="{ 'selected': selectVal.value.includes(item.value) }"
                @click="changeVal(item)"
              />
            </div>
          </van-index-bar>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { countryList } from '@/utils/country.js'

export default {
  props: {
    fieldNames: {
      type: Object,
      default: () => {
        return {
          label: 'country',
          value: 'value'
        }
      }
    },
    value: {
      type: [String, Array]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: {
      handler (newVal) {
        if (newVal) {
          const allCountries = this.getAllCountries()
          const found = allCountries.find(item => item.value === newVal)
          if (found) {
            this.showVal = `+${found.value}`
            this.selectVal = {
              label: [found[this.fieldNames.label]],
              value: [found[this.fieldNames.value]]
            }
          } else {
            this.resetSelection()
          }
        } else {
          this.resetSelection()
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      selectShow: false,
      selectVal: {
        label: [],
        value: []
      },
      showVal: '',
      commonList: [
        { country: this.$t('shared.filter.unitedStates'), value: '1' },
        { country: this.$t('shared.filter.unitedKingdom'), value: '44' },
        { country: this.$t('shared.filter.russia'), value: '7' }
      ],
      countryList: {},
      indexList: []
    }
  },
  created () {
    this.processCountryData()
  },
  methods: {
    processCountryData () {
      const grouped = {}
      const indexList = new Set()

      countryList.forEach(item => {
        const char = item.pinyin.charAt(0).toUpperCase()
        if (!grouped[char]) {
          grouped[char] = []
        }
        grouped[char].push({ country: item.en, value: item.code })
        indexList.add(char)
      })

      this.countryList = grouped
      this.indexList = Array.from(indexList).sort()
    },
    getAllCountries () {
      let all = [...this.commonList]
      for (const key in this.countryList) {
        all = all.concat(this.countryList[key])
      }
      return all
    },
    resetSelection () {
      this.selectVal = { label: [], value: [] }
      this.showVal = ''
    },
    changeVal (params) {
      this.selectVal.label = [params[this.fieldNames.label]]
      this.selectVal.value = [params[this.fieldNames.value]]
      this.confirmFilter()
    },
    confirmFilter () {
      this.showVal = `+${this.selectVal.value.join(',')}`
      this.$emit('input', this.selectVal.value.join(','))
      this.selectShow = false
    },
    handleOper () {
      if (this.disabled) return
      this.selectShow = true
    }
  }
}
</script>

<style lang="less" scoped>
.xu-country-code {
  width: 100%;
  font-size: 14px;
  .field-txt {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 35px;
    padding: 0px 10px;
    border: 1px solid #b9cbed;
    border-radius: 5px;
    .txt-label {
      flex: 1;
      color: #000;
    }
    .isDisable {
      color: #c8c9cc;
    }
  }
}
.other-content {
  display: flex;
  flex-direction: column;
  height: 80vh;
  .filter-popup-title {
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    padding: 10px 0;
    position: sticky;
    top: 0;
    background: white;
    z-index: 1;
  }
  .area-content {
    flex: 1;
    overflow: hidden;
    overflow-y: auto;
  }
  /deep/ .van-index-bar {
    // height: calc(100% - 50px); // Adjust based on title height
    height: 100%;
    overflow-y: auto;
  }

  /deep/ .van-cell {
    padding: 10px 18px;
    font-size: 14px;
  }

  /deep/ .van-cell.selected .van-cell__title {
    color: #ee541b;
  }

  /deep/ .van-index-anchor {
    background-color: #f7f8fa;
    padding: 8px 18px;
    font-size: 14px;
    color: #969799;
  }

  /deep/ .van-index-bar__sidebar {
    display: flex;
    flex-direction: column;
    justify-content: center;
    right: 5px;
    .van-index-bar__index {
      padding: 2px 0;
      font-size: 12px;
    }
  }
}
</style>
